export default {
      id: "carte_alu-usage",
      viewBox: "0 0 845 777",
      url: "../dist/images/" + "sprite.svg#carte_alu-usage",
      toString: function () {
        return this.url;
      }
    }